import attributes from './attributes';
import optionTypes from './option-types';

export default {
  [optionTypes.PAGINATION]: attributes.PAGINATION,
  [optionTypes.NAVIGATION]: attributes.NAVIGATION_BUTTONS,
  [optionTypes.TRANSITION]: attributes.TRANSITION_TYPE,
  [optionTypes.AUTO_CHANGE]: attributes.AUTO_CHANGE,
};
